import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = { key: 'thatchedRoof' }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, "Er der stråtag på din bolig?", -1)
const _hoisted_4 = {
  class: "text-left mb-3",
  key: "thatchedRoofErr"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: "familyMemberCountLabel",
  class: "input__label",
  textContent: 'Antal personer i husstanden'
}
const _hoisted_8 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressSearchComponent = _resolveComponent("AddressSearchComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_ExistingAbProductsComponent = _resolveComponent("ExistingAbProductsComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AddressSearchComponent, {
        id: "address",
        key: "address",
        elementId: "address",
        label: "Adresse",
        placeholder: "F.eks Gadenavn 29, 2.tv...",
        defaultValue: _ctx.model.personInfo.address || _ctx.defaultAddress,
        isValid: _ctx.model.personInfo.address !== undefined,
        visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
        onAddressSearch: _ctx.addressSearch
      }, null, 8, ["defaultValue", "isValid", "visibleError", "onAddressSearch"])
    ]),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.model.personInfo.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                  key: 'thatchedRoof' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "thatchedRoof",
                    id: 'thatchedRoof' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.personInfo.thatchedRoof,
                    trackingLabel: "Er der stråtag på din bolig?",
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.personInfo.thatchedRoof)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_inputFieldComponent, {
          class: "text-left pb-3",
          key: "customerAge",
          id: "customerAge",
          name: "customerAge",
          placeholder: "F.eks. 42 ",
          label: "Din alder",
          readonlyValue: _ctx.readonlyAge,
          validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          innerData: _ctx.model.personInfo,
          required: true
        }, null, 8, ["readonlyValue", "validateOnLoad", "visibleError", "innerData"]), [
          [_vShow, _ctx.model.personInfo.address && _ctx.model.personInfo.thatchedRoof && !_ctx.readonlyAge]
        ]),
        (
					_ctx.model.personInfo.address &&
					_ctx.model.personInfo.thatchedRoof &&
					_ctx.fieldValidator.isValidAge(_ctx.model.personInfo.customerAge)
				)
          ? (_openBlock(), _createElementBlock("label", _hoisted_7))
          : _createCommentVNode("", true),
        (
					_ctx.model.personInfo.address &&
					_ctx.model.personInfo.thatchedRoof &&
					_ctx.fieldValidator.isValidAge(_ctx.model.personInfo.customerAge)
				)
          ? (_openBlock(), _createBlock(_component_SelectModalComponent, {
              key: "familyMemberCount",
              id: "familyMemberCount",
              name: "familyMemberCount",
              preSelect: _ctx.model.personInfo.familyMemberCount,
              innerData: _ctx.familyMemberList,
              selected: _ctx.model.personInfo.familyMemberCount !== undefined,
              placeholder: "Vælg antal personer i husstand",
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              errorMsgOverride: "Vælg antal personer i husstand",
              readonlyValue: _ctx.readonlyFamilyMemberCount,
              "onSelectModalComponent:selected": _ctx.familyMemberSelected
            }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "readonlyValue", "onSelectModalComponent:selected"]))
          : _createCommentVNode("", true),
        (
					_ctx.model.personInfo.address &&
					_ctx.model.personInfo.thatchedRoof &&
					_ctx.fieldValidator.isValidAge(_ctx.model.personInfo.customerAge) &&
					_ctx.model.showExistingAlmBrandProducts &&
					_ctx.model.personInfo.familyMemberCount &&
					_ctx.model.personInfo.thatchedRoof
				)
          ? (_openBlock(), _createBlock(_component_ExistingAbProductsComponent, {
              class: "pt-3",
              key: "ExistingAbProductsComponent",
              card: _ctx.card
            }, null, 8, ["card"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.card.linkText), 1)
        ]),
        _: 1
      }, 8, ["class", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}